import { apiClient } from './client.js'
import type { User, UserAvatarResponse } from '../models/user.js'
import type { FetchOptions } from '../models/common.js'

export interface CreateUserPayload {
  first_name: string
  last_name: string
  email: string
  role_handle: string
}

export async function createUser(
  payload: CreateUserPayload,
  options: FetchOptions = {},
): Promise<User> {
  return await apiClient.post<User>('/v1/users', payload, {
    withAuth: true,
    signal: options.signal,
  })
}

export interface ProfileImageUploadResponse {
  id: string
  storage?: string
  metadata?: { filename?: string }
}

export async function uploadProfileImage(
  file: File,
  options: FetchOptions = {},
): Promise<ProfileImageUploadResponse> {
  const form = new FormData()
  // Shrine upload endpoints expect multipart field name "file".
  form.append('file', file, file.name)
  return await apiClient.postForm<ProfileImageUploadResponse>(
    '/profile_images/upload',
    form,
    { withAuth: true, signal: options.signal },
  )
}

export async function updateUserPassword(
  userId: number,
  newPassword: string,
  newPasswordConfirm: string,
  options: FetchOptions = {},
): Promise<UserAvatarResponse> {
  return await apiClient.put<UserAvatarResponse>(
    `/v1/users/${encodeURIComponent(String(userId))}`,
    { new_password: newPassword, new_password_confirm: newPasswordConfirm },
    { withAuth: true, signal: options.signal },
  )
}

export async function setUserProfileImage(
  userId: number,
  profileImageId: string,
  profileImageName?: string,
  options: FetchOptions = {},
): Promise<UserAvatarResponse> {
  const payload: { profile_image_id: string; profile_image_name?: string } = {
    profile_image_id: profileImageId,
  }
  if (profileImageName) payload.profile_image_name = profileImageName
  return await apiClient.put<UserAvatarResponse>(
    `/v1/users/${encodeURIComponent(String(userId))}`,
    payload,
    { withAuth: true, signal: options.signal },
  )
}
